import React, { useContext } from 'react'
import { FaQuoteLeft, FaStar } from 'react-icons/fa'
import female from '../../assets/avatar/female.png'
import male from '../../assets/avatar/male.png'
import classes from './Testimonial.module.css'

import { Autoplay, Navigation, Pagination } from "swiper"
import "swiper/css"
import "swiper/css/autoplay"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from 'swiper/react'
import { mouseContext } from '../../context/mouseContext'

const Testimonial = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext)

  // ⭐ Updated function with ratings
  function createSlide(name, identity, comment, gender, link = '', rating = 5) {
    return (
      <SwiperSlide>
        <div className={classes.testimonial}>
          <span onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
            <img
              src={gender === 'male' ? male : female}
              alt={gender}
              className={classes.avatar}
            />
          </span>
          <h2 onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
            {name}
          </h2>
          <h4>{identity}</h4>

          {/* ⭐ Star Ratings */}
          <div className={classes.stars}>
            {Array.from({ length: 5 }, (_, i) => (
              <FaStar
                key={i}
                className={i < rating ? classes.starFilled : classes.starEmpty}
              />
            ))}
          </div>

          <p>
            <FaQuoteLeft style={{ opacity: 0.2, fontSize: '2rem' }} /> &nbsp;{comment}
            {link.length !== 0 && (
              <a
                target="_blank"
                rel="noreferrer"
                href="https://blog.internshala.com/2021/11/pursuing-a-career-in-materials-science-taking-the-road-less-travelled/"
                style={{ color: 'blue', textDecoration: 'underline' }}
              >
                Pursuing a career in materials science: Taking the road less travelled | Internshala blog
              </a>
            )}
          </p>
        </div>
      </SwiperSlide>
    )
  }

  return (
    <div className={classes.section} style={{ backgroundColor: "whitesmoke" }}>
      <h1 className={classes.heading}>
        Know How IQApex Labs is Transforming Lives around the World
      </h1>

      <div className={classes.testimonials}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
        >
          {createSlide("Meghana Hegde", "IIM Kozhikode", "I wish to convey my gratitude to team IQApex...", "female", "", 5)}
          {createSlide("Ayush Chaudhary", "IIT Indore", "It was a wonderful experience for me...", "male", "", 4)}
          {createSlide("Harsh Sinha", "IIT Guwahati", "I gained much knowledge at IQApex...", "male", "", 5)}
          {createSlide("Bidisha Bhattacharya", "NIT Durgapur", "The innovative projects that your team demonstrates...", "female", "", 5)}
          {createSlide("Simran Malik", "National University Singapore", "", "female", "Pursuing a career in materials science...", 4)}
          {createSlide("Jayasmita Roy", "Skema Business School, France", "Mr. Arjun is someone that you will enjoy working with...", "female", "", 5)}
          {createSlide("Hrithik Ghatny", "Oracle, System Engineer", "Thank you team IQApex for the wonderful experience...", "male", "", 4)}
          {createSlide("Ananda Mukherjee", "IIT Guwahati", "Life in IQApex - we learnt how to build things...", "male", "", 5)}
          {createSlide("Arijit Mandal", "SBI", "I cannot forget the time I spent with IQApex Labs...", "male", "", 5)}
          {createSlide("Pratik Sarode", "BOSCH Ltd.", "I would like to thank Team IQApex for support...", "male", "", 4)}
          {createSlide("Yadhu Nair", "Amrita School of Engineering", "Thank you so much for acknowledging my work...", "male", "", 5)}
          {createSlide("Samadrita Chanda", "St.Xavier’s College, Kolkata", "The experience of conducting research...", "female", "", 5)}
        </Swiper>
      </div>
    </div>
  )
}

export default Testimonial
